<div class="c-footerContainer">
  <div class="l-page">
    <div *ngIf="this.footerContent" [innerHTML]="footerContent"></div>
  </div>
</div>